import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface TrialExpiredBannerProps {
  onPayNow: () => void;
  canPayNow: boolean;
}

export function TrialExpiredBanner({ onPayNow, canPayNow }: TrialExpiredBannerProps) {
  const { t } = useTranslation();

  return (
    <Alert className="border-amber-500/30 bg-amber-50 text-amber-950 dark:bg-amber-500/10 dark:text-amber-100">
      <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-300" />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-1">
          <AlertTitle className="text-amber-950 dark:text-amber-100">
            {t('customer.planManagement.trialExpired.title')}
          </AlertTitle>
          <AlertDescription className="text-amber-900/80 dark:text-amber-100/80">
            {t('customer.planManagement.trialExpired.description')}
          </AlertDescription>
        </div>
        {canPayNow ? (
          <Button
            type="button"
            size="sm"
            onClick={onPayNow}
            className="w-full shrink-0 sm:w-auto"
          >
            {t('customer.planManagement.trialExpired.payNow')}
          </Button>
        ) : null}
      </div>
    </Alert>
  );
}
